// Theme corner radius in px, read from the `--radius` CSS variable in
// index.css. Components that animate border-radius through framer-motion need
// a number, not a CSS var — this bridges the two. Cached: the value does not
// change between light/dark.

let cached: number | null = null;

export function getThemeRadius(): number {
  if (cached !== null) return cached;
  if (typeof window === "undefined") return 10;
  const root = document.documentElement;
  const styles = getComputedStyle(root);
  const raw = styles.getPropertyValue("--radius").trim();
  let value = 10;
  if (raw.endsWith("rem")) {
    const rem = parseFloat(styles.fontSize) || 16;
    const parsed = parseFloat(raw);
    if (!Number.isNaN(parsed)) value = parsed * rem;
  } else {
    const parsed = parseFloat(raw);
    if (!Number.isNaN(parsed)) value = parsed;
  }
  cached = value;
  return value;
}
